module.exports = __webpack_public_path__ + "media/images/prize__service-44565d904fa2bcb2cc2b9c85e6dcbc24.jpg";